<div class="layout-inner" [class.has-warning-message]="warningDisplayed">
    <app-flash></app-flash>
    <app-warning (displayed)="onWarningDisplayed($event)" [status]="authenticatedStatus$ | async"></app-warning>
    <router-outlet></router-outlet>
</div>

